import { Action } from '@appTypes/Action';
import { AutoAssignList } from '@enums/MapperType';
import {
  ADD_AUTO_ASSIGN_LIST,
  SET_ASSIGN_ALL_BUTTON_CLICK,
  SET_REVERT_BUTTON,
  SET_REVERT_CHANGES,
  SET_SAVE_BUTTON_CLICK,
} from './dmsMapperActionTypes';

interface DmsMapperState {
  autoAssignAll: boolean;
  autoAssignList: AutoAssignList[];
  revertChanges: boolean;
  isRevertButton: boolean;
  saveButton: boolean;
}

export const initialDmsMapperState: DmsMapperState = {
  autoAssignAll: false,
  autoAssignList: [],
  revertChanges: false,
  isRevertButton: false,
  saveButton: false,
};

const dmsMapperReducer = (state = initialDmsMapperState, action: Action): DmsMapperState => {
  switch (action.type) {
    case SET_ASSIGN_ALL_BUTTON_CLICK:
      return {
        ...state,
        autoAssignAll: action.payload,
      };

    case ADD_AUTO_ASSIGN_LIST:
      return {
        ...state,
        autoAssignList: action.payload,
      };

    case SET_REVERT_CHANGES:
      return {
        ...state,
        revertChanges: action.payload,
      };

    case SET_REVERT_BUTTON:
      return {
        ...state,
        isRevertButton: action.payload,
      };

    case SET_SAVE_BUTTON_CLICK:
      return {
        ...state,
        saveButton: action.payload,
      };

    default:
      return state;
  }
};

export default dmsMapperReducer;
